import React from "react";
import { Moon, Sun, Languages } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";
import { useLang } from "@/contexts/LanguageContext";

export const ThemeToggle = () => {
  const { theme, toggle } = useTheme();
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      className="w-10 h-10 inline-flex items-center justify-center rounded-full border border-[var(--so-border)] hover:border-[var(--so-orange)] transition-colors"
      aria-label="Toggle theme"
    >
      {theme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
};

export const LanguageToggle = () => {
  const { lang, toggle } = useLang();
  return (
    <button
      onClick={toggle}
      data-testid="language-toggle"
      className="h-10 px-3 inline-flex items-center gap-2 rounded-full border border-[var(--so-border)] hover:border-[var(--so-orange)] transition-colors text-sm font-semibold"
      aria-label="Toggle language"
    >
      <Languages className="w-4 h-4" />
      <span>{lang === "en" ? "AR" : "EN"}</span>
    </button>
  );
};
